import { useTranslation } from 'react-i18next';

import useEvents from 'lib/hooks/useEvents';
import ExpandCollapseTap from 'lib/Tracking/Srp/SearchFilters/ExpandCollapseTap';
import { Features } from 'lib/EventSchema';

import { useContext, memo } from 'react';
import SrpEventContext from 'contexts/SrpEventContext';
import Accordion from 'components/Shared/SearchFilter/Accordion';
import { DoorCountFacet, BodyStyleFacet } from 'lib/apis/SearchApi/types';
import BodyTypesFilter from './BodyTypesFilter';
import DoorsFilter from './DoorsFilter';

const BodyStylesFilter = memo(function BodyStylesFilter({
  expanded,
  doorCountFacets,
  bodyStyleFacets,
}: {
  expanded?: boolean;
  doorCountFacets?: DoorCountFacet;
  bodyStyleFacets?: BodyStyleFacet;
}): JSX.Element {
  const logger = useEvents();
  const { sourcePage } = useContext(SrpEventContext);
  const { t } = useTranslation();

  function onToggle(isExpanding: boolean): Promise<void> {
    return logger.log(ExpandCollapseTap({ feature: Features.bodyStyles, isExpanding, sourcePage }));
  }
  return (
    <Accordion title={t('srp.filters.bodyStyles.header')} expanded={expanded} onClick={onToggle}>
      <DoorsFilter doorCountFacets={doorCountFacets} />
      <BodyTypesFilter bodyStyleFacets={bodyStyleFacets} />
    </Accordion>
  );
});

export default BodyStylesFilter;
